import Loader from "react-loader-spinner";
import { useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { Card, Form } from "react-bootstrap";
import { useForm } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';
import { GetAllProduct } from "../store/api/GetAllProduct";
import { attachFile } from "../store/api/Services";
import { getComplaintsMainGroupList, getComplaintsSubGroup, getComplaintsTargetList, addNewComplaint } from "../store/api/ComplaintsAPI";
const Complaint = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const complaintAttachment = useRef();
    const { serviceType, serviceID, serviceNumber, productSerial, productID } = useParams();
    useEffect(() => {
        document.body.classList = "notMain";
        dispatch(GetAllProduct());
        dispatch(getComplaintsMainGroupList());
        dispatch(getComplaintsTargetList());
    }, []);

    const { register, handleSubmit, errors } = useForm();
    const { productData } = useSelector(state => { return { productData: state.customerDataReducer.productData } });
    const { complaintsMainGroups, complaintsSubGroups, complaintsTargetList } = useSelector(state => { return { complaintsMainGroups: state.ComplaintsReducer.complaintsMainGroups, complaintsSubGroups: state.ComplaintsReducer.complaintsSubGroups, complaintsTargetList: state.ComplaintsReducer.complaintsTargetList } });
    const loadSubGroups = (mainGroupID) => {
        dispatch(getComplaintsSubGroup(mainGroupID));
    }
    const attachNewFile = (id) => {
        let f = complaintAttachment.current.files;
        if (f.length > 0) {
            attachFile(complaintAttachment.current, id, "ComplaintsAttachment", () => { history.push("/") });
        }
        else {
            history.push("/");
        }
    }
    const onSubmit = (data) => {
        if (serviceID && serviceID !== "0") {
            data.RelatedServiceID = serviceID;
        }
        dispatch(addNewComplaint(data, attachNewFile));
    };
    return (
        <div className="container-fluid mt-4">
            <Card>
                <Card.Header className="headerStyle">ثبت شکایت</Card.Header>
                <Card.Body className="bodyStyle">
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="row">
                            <div className="form-group col-md-3">
                                <label>گروه اصلی شکایت </label>
                                <select className="form-control" onChange={e => loadSubGroups(e.target.value)}>
                                    <option>انتخاب کنید</option>
                                    {complaintsMainGroups && Array.isArray(complaintsMainGroups) && complaintsMainGroups.map((item, i) => {
                                        return (
                                            <option key={i} value={item.MainGroupID}> {item.MainGroupName}</option>
                                        )
                                    })}
                                </select>
                            </div>
                            <div className="form-group col-md-3">
                                <label>گروه فرعی شکایت </label>
                                <select className="form-control" name="GroupID" ref={register({})}>
                                    <option>انتخاب کنید</option>
                                    {complaintsSubGroups && Array.isArray(complaintsSubGroups) && complaintsSubGroups.map((item, i) => {
                                        return (
                                            <option key={i} value={item.GroupID}> {item.GroupName}</option>
                                        )
                                    })}
                                </select>
                            </div>
                            <div className="form-group col-md-3">
                                <label>بخش مورد شکایت</label>
                                <select className="form-control" name="TargetID" ref={register({})}>
                                    <option>انتخاب کنید</option>
                                    {complaintsTargetList && Array.isArray(complaintsTargetList) && complaintsTargetList.map((item, i) => {
                                        return (
                                            <option key={i} value={item.ID}> {item.Target}</option>
                                        )
                                    })}
                                </select>
                            </div>
                            <div className="form-group col-md-3">
                                <label>نام و مدل محصول</label>
                                {(!productData || !Array.isArray(productData) || productData.length === 0) &&
                                    <div className="form-control">
                                        <Loader type="BallTriangle" color="#bb1370" width={25} height={25}/>
                                    </div>
                                }
                                {productData && Array.isArray(productData) &&
                                    <select className="form-control" name="ProductID" defaultValue={productID} ref={register({})}>
                                        <option value=""> لطفا انتخاب کنید </option>
                                        {productData.map((item, i) => {
                                            return (
                                                <option key={i} value={item.ProductId}> {item.Name + "--" + item.Model}</option>
                                            )
                                        })}
                                    </select>
                                }
                            </div>
                            <div className="form-group col-md-3">
                                <label>نوع سرویس</label>
                                <select className="form-control" defaultValue={serviceType} name="RelatedServiceType" ref={register({})}>
                                    <option value="">انتخاب کنید</option>
                                    <option value="install">نصب</option>
                                    <option value="repair">تعمیر</option>
                                </select>
                            </div>
                            <div className="form-group col-md-3">
                                <label>شماره سرویس</label>
                                <input type='number' className="form-control" value={serviceNumber} readOnly />
                                <small style={{ color: "#a91465" }}>این فیلد قابل ویرایش نیست و هنگام باز شدن از صفحه کارهای من پر میشود</small>
                            </div>
                            <div className="form-group col-md-3">
                                <label>سریال محصول</label><span style={{ color: "red" }}>*</span>
                                <input type='text' className="form-control" name="ProductSerial" defaultValue={productSerial} ref={register({ required: true })} />
                                {errors.ProductSerial && <small className="errors"> شماره سریال را وارد کنید </small>}
                            </div>
                            <div className="form-group col-md-3">
                                <label>پیوست</label>
                                <input className="form-control" style={{ fontSize: "13px" }} type="file" ref={complaintAttachment} />
                            </div>
                        </div>
                        <div className="row">
                            <div className="form-group">
                                <label>عنوان شکایت</label><span style={{ color: "red" }}>*</span>
                                <input type="text" className="form-control" name="Title" ref={register({ required: true })} />
                                {errors.Title && <small className="errors"> عنوان شکایت را وارد کنید </small>}
                            </div>
                        </div>
                        <div className="row">
                            <div className="form-group">
                                <label>متن شکایت</label><span style={{ color: "red" }}>*</span>
                                <Form.Control as="textarea" name="Body" ref={register({ required: true })} />
                                {errors.Body && <small className="errors"> متن شکایت را وارد کنید </small>}
                            </div>
                        </div>
                        <button className="btn btn-block btn-success w-100 mt-2">ثبت شکایت</button>
                    </form>

                </Card.Body>

            </Card>
        </div>
    );
}
export default Complaint;